/* eslint-disable */
import React, {useState} from 'react';
import 'contents/assets/scss/page/statistics.scss';
import Tab from '../../component/Inc/Tab';
import LineChart from '../../component/Inc/LineChart';
import Paging from '../../component/Inc/Paging';

const PromotionCall = () => {
  const lineChartWidth = '100%';
  const lineChartHeight = '200px';
  const [isOrderActive1, setIsOrderActive1] = useState(false);
  //Tab Component
  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    {title: '월별', value: 0},
    {title: '홍보교사 별', value: 1},
    {title: '과목별', value: 2}
  ];

  //Linechartlabels
  const lineChartlabels = ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'];

  //PromotionCall data by Month
  const lineChartDataMonth = {
    lineChartlabels,
    datasets: [
      {
        label: '시범강의 요청 수',
        data: [1, 5, 9, 8, 1, 4, 5, 6, 3, 3, 10, 4],
        fill: false,
        borderColor: '#d1cdca',
        borderWidth: 1,
        backgroundColor: '#fc8019'
      },
      {
        label: '시범강의 성공 수',
        data: [7, 7.5, 4.5, 5.25, 6.5, 6.85, 8, 3, 1, 7, 6, 9.5],
        fill: false,
        borderColor: '#d1cdca',
        borderWidth: 1,
        backgroundColor: '#3780ff'
      },
      {
        label: '등록 수업 수',
        data: [3, 4, 6, 5, 8.5, 4.85, 2, 6, 7, 9, 3, 10],
        fill: false,
        borderColor: '#d1cdca',
        borderWidth: 1,
        backgroundColor: '#6d747f'
      },
      {
        label: '등록 학생 수',
        data: [1, 2.5, 3, 2.8, 2.1, 3.25, 2.4, 4, 3.7, 1.8, 4.3, 2.2],
        fill: false,
        borderColor: '#d1cdca',
        borderWidth: 1,
        backgroundColor: '#8f55ff'
      }
    ]
  };

  //PromotionCall data by Teacher
  const lineChartDataTeacher = {
    lineChartlabels,
    datasets: [
      {
        label: '시범강의 요청 수',
        data: [1, 5, 9, 8, 1, 4, 5, 6, 3, 3, 10, 4],
        fill: false,
        borderColor: '#d1cdca',
        borderWidth: 1,
        backgroundColor: '#fc8019'
      },
      {
        label: '시범강의 성공 수',
        data: [7, 7.5, 4.5, 5.25, 6.5, 6.85, 8, 3, 1, 7, 6, 9.5],
        fill: false,
        borderColor: '#d1cdca',
        borderWidth: 1,
        backgroundColor: '#3780ff'
      },
      {
        label: '등록 수업 수',
        data: [3, 4, 6, 5, 8.5, 4.85, 2, 6, 7, 9, 3, 10],
        fill: false,
        borderColor: '#d1cdca',
        borderWidth: 1,
        backgroundColor: '#6d747f'
      },
      {
        label: '등록 학생 수',
        data: [1, 2.5, 3, 2.8, 2.1, 3.25, 2.4, 4, 3.7, 1.8, 4.3, 2.2],
        fill: false,
        borderColor: '#d1cdca',
        borderWidth: 1,
        backgroundColor: '#8f55ff'
      }
    ]
  };

  //PromotionCall data by Subject
  const lineChartDataSubject = {
    lineChartlabels,
    datasets: [
      {
        label: '시범강의 요청 수',
        data: [1, 5, 9, 8, 1, 4, 5, 6, 3, 3, 10, 4],
        fill: false,
        borderColor: '#d1cdca',
        borderWidth: 1,
        backgroundColor: '#fc8019'
      },
      {
        label: '시범강의 성공 수',
        data: [7, 7.5, 4.5, 5.25, 6.5, 6.85, 8, 3, 1, 7, 6, 9.5],
        fill: false,
        borderColor: '#d1cdca',
        borderWidth: 1,
        backgroundColor: '#3780ff'
      },
      {
        label: '등록 수업 수',
        data: [3, 4, 6, 5, 8.5, 4.85, 2, 6, 7, 9, 3, 10],
        fill: false,
        borderColor: '#d1cdca',
        borderWidth: 1,
        backgroundColor: '#6d747f'
      },
      {
        label: '등록 학생 수',
        data: [1, 2.5, 3, 2.8, 2.1, 3.25, 2.4, 4, 3.7, 1.8, 4.3, 2.2],
        fill: false,
        borderColor: '#d1cdca',
        borderWidth: 1,
        backgroundColor: '#8f55ff'
      }
    ]
  };
  return (
    <main className="com_container com_statistics p_promotion_call">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu10_8">홍보전화 통계</h2>
        </section>
        <section className="com_pg_container">
          <div className="box full ">
            <div className="com_board_list__top">
              <Tab data={tab} tab={tabIdx} setTab={setTabIdx} />

              <section className="com_board_search">
                <article className="search">
                  <input type="search" placeholder="검색할 내용을 입력해 주세요." className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>

            <hr className="com_divider" />
            {/* promotion call by month and teacher : menu */}
            {(tabIdx === 0 || tabIdx === 1) && (
              <div className="com_calendar_wrap">
                <div className="year">
                  <button className="btn btn_first"></button>
                  <button className="btn btn_prev"></button>
                  <button className="btn_txt">2023</button>
                  <button className="btn btn_next"></button>
                  <button className="btn btn_last"></button>
                </div>
              </div>
            )}

            {/* promotion call by subject : menu */}
            {tabIdx === 2 && (
              <>
                <div className="com_calendar_wrap has_option">
                  <div className="option">
                    <select className="select s">
                      <option value="이지수능 (본사)">이지수능 (본사)</option>
                    </select>
                  </div>
                  <div className="year ">
                    <button className="btn btn_first"></button>
                    <button className="btn btn_prev"></button>
                    <button className="btn_txt">2023</button>
                    <button className="btn btn_next"></button>
                    <button className="btn btn_last"></button>
                  </div>
                  <div className="com_count_wrapper">
                    <div className="operators">
                      <div className="operators_label">
                        <span className="operators_count">총 영업자 수</span>
                        <span className="operators_value">98명</span>
                      </div>
                    </div>
                    <div className="turnover">
                      <div className="turnover_label">
                        <span className="turnover_count">총 매출액</span>
                        <span className="turnover_value">46,500,000</span>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}

            {/* promotion call by month */}
            {tabIdx === 0 && (
              <div className="month_wrapper">
                <div className="com_chart_wrap">
                  <div className="chart_body">
                    <div className="chart_name">
                      <div className="chart_item">
                        <span className="chart_name_label">시범강의 요청 수</span>
                        <div className="chart_slider chart_orange"></div>
                      </div>
                      <div className="chart_item">
                        <span className="chart_name_label">시범강의 성공 수</span>
                        <div className="chart_slider chart_blue"></div>
                      </div>
                      <div className="chart_item">
                        <span className="chart_name_label">등록 수업 수</span>
                        <div className="chart_slider chart_gray"></div>
                      </div>
                      <div className="chart_item">
                        <span className="chart_name_label">등록 학생 수</span>
                        <div className="chart_slider chart_indigo"></div>
                      </div>
                    </div>
                    <div className="chart_content">
                      <LineChart data={lineChartDataMonth} width={lineChartWidth} height={lineChartHeight} />
                    </div>
                  </div>
                </div>
                <table className="com_board_list">
                  <tbody>
                    <tr>
                      <th>총 전화수</th>
                      <td className="td_point">46514</td>
                      <th>통화시간</th>
                      <td className="td_point">45시간 35분</td>
                      <th>시범강의 요청 수</th>
                      <td className="td_point">3625건</td>
                      <th>시범강의 성공 수</th>
                      <td className="td_point">457건</td>
                    </tr>
                  </tbody>
                </table>
                <table className="com_board_list">
                  <colgroup>
                    <col width="{{ width: 'calc(100% / 9)' }}" />
                    <col width="{{ width: 'calc(100% / 9)' }}" />
                    <col width="{{ width: 'calc(100% / 9)' }}" />
                    <col width="{{ width: 'calc(100% / 9)' }}" />
                    <col width="{{ width: 'calc(100% / 9)' }}" />
                    <col width="{{ width: 'calc(100% / 9)' }}" />
                    <col width="{{ width: 'calc(100% / 9)' }}" />
                    <col width="{{ width: 'calc(100% / 9)' }}" />
                    <col width="{{ width: 'calc(100% / 9)' }}" />
                  </colgroup>
                  <thead>
                    <tr>
                      <th>NO</th>
                      <th>
                        홍보 교사명
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        총 전화수
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        통화 수
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        시범강의 요청수
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        총 통화 시간
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        시범강의 성공 수
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        등록수업 수
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        등록수업 수
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>1</td>
                      <td>김홍보103</td>
                      <td>475</td>
                      <td>475</td>
                      <td>475</td>
                      <td>2시간 30분</td>
                      <td className="td_point">45</td>
                      <td className="td_point">4</td>
                      <td className="td_point">142</td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td>김홍보103</td>
                      <td>475</td>
                      <td>475</td>
                      <td>475</td>
                      <td>2시간 30분</td>
                      <td className="td_point">45</td>
                      <td className="td_point">4</td>
                      <td className="td_point">142</td>
                    </tr>
                    <tr>
                      <td>3</td>
                      <td>김홍보103</td>
                      <td>475</td>
                      <td>475</td>
                      <td>475</td>
                      <td>2시간 30분</td>
                      <td className="td_point">45</td>
                      <td className="td_point">4</td>
                      <td className="td_point">142</td>
                    </tr>
                    <tr>
                      <td>4</td>
                      <td>김홍보103</td>
                      <td>475</td>
                      <td>475</td>
                      <td>475</td>
                      <td>2시간 30분</td>
                      <td className="td_point">45</td>
                      <td className="td_point">4</td>
                      <td className="td_point">142</td>
                    </tr>
                    <tr>
                      <td>5</td>
                      <td>김홍보103</td>
                      <td>475</td>
                      <td>475</td>
                      <td>475</td>
                      <td>2시간 30분</td>
                      <td className="td_point">45</td>
                      <td className="td_point">4</td>
                      <td className="td_point">142</td>
                    </tr>
                    <tr>
                      <td>7</td>
                      <td>김홍보103</td>
                      <td>475</td>
                      <td>475</td>
                      <td>475</td>
                      <td>2시간 30분</td>
                      <td className="td_point">45</td>
                      <td className="td_point">4</td>
                      <td className="td_point">142</td>
                    </tr>
                    <tr className="summarized_rows">
                      <td colSpan="2">2023</td>
                      <td className="td_point">6546</td>
                      <td className="td_point">142</td>
                      <td className="td_point">142</td>
                      <td className="td_point">142</td>
                      <td className="td_point">142</td>
                      <td className="td_point">142</td>
                      <td className="td_point">654,654,000</td>
                    </tr>
                    <tr className="summarized_rows">
                      <td colSpan="2">2022</td>
                      <td>654</td>
                      <td>142</td>
                      <td>142</td>
                      <td>142</td>
                      <td>142</td>
                      <td>142</td>
                      <td>1,057,000</td>
                    </tr>

                    <tr className="summarized_rows">
                      <td colSpan="2">증감율</td>
                      <td className="td_red">
                        <span className="arrow_blue">3214</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">654</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">654</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">654</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">654</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">654</span>
                      </td>
                      <td className="td_point">
                        <span className="arrow_blue down">3214</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <Paging />
              </div>
            )}
            {/* promotion call by teacher */}
            {tabIdx === 1 && (
              <div className="teacher_wrapper">
                <div className="com_chart_wrap">
                  <div className="chart_body">
                    <div className="chart_name">
                      <div className="chart_item">
                        <span className="chart_name_label">시범강의 요청 수</span>
                        <div className="chart_slider chart_orange"></div>
                      </div>
                      <div className="chart_item">
                        <span className="chart_name_label">시범강의 성공 수</span>
                        <div className="chart_slider chart_blue"></div>
                      </div>
                      <div className="chart_item">
                        <span className="chart_name_label">등록 수업 수</span>
                        <div className="chart_slider chart_gray"></div>
                      </div>
                      <div className="chart_item">
                        <span className="chart_name_label">등록 학생 수</span>
                        <div className="chart_slider chart_indigo"></div>
                      </div>
                    </div>
                    <div className="chart_content">
                      <LineChart data={lineChartDataTeacher} width={lineChartWidth} height={lineChartHeight} />
                    </div>
                  </div>
                </div>
                <table className="com_board_list">
                  <tbody>
                    <tr>
                      <th>총 전화수</th>
                      <td className="td_point">46514</td>
                      <th>통화시간</th>
                      <td className="td_point">45시간 35분</td>
                      <th>시범강의 요청 수</th>
                      <td className="td_point">3625건</td>
                      <th>시범강의 성공 수</th>
                      <td className="td_point">457건</td>
                    </tr>
                  </tbody>
                </table>
                <div className="check">
                  <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
                  <label htmlFor="rdo01">전체</label>
                  <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
                  <label htmlFor="rdo02">시범강의 요청 수</label>
                  <input type="radio" name="rdo" id="rdo03" className="com_chk circle" />
                  <label htmlFor="rdo03">시범강의 성공 수</label>
                  <input type="radio" name="rdo" id="rdo04" className="com_chk circle" />
                  <label htmlFor="rdo04">등록 수업 수</label>
                  <input type="radio" name="rdo" id="rdo05" className="com_chk circle" />
                  <label htmlFor="rdo05">등록 학생 수</label>
                </div>
                <table className="com_board_list type_row_big">
                  <colgroup>
                    <col width="{{ width: 'calc(100% / 14)' }}" />
                    <col width="{{ width: 'calc(100% / 14)' }}" />
                    <col width="{{ width: 'calc(100% / 14)' }}" />
                    <col width="{{ width: 'calc(100% / 14)' }}" />
                    <col width="{{ width: 'calc(100% / 14)' }}" />
                    <col width="{{ width: 'calc(100% / 14)' }}" />
                    <col width="{{ width: 'calc(100% / 14)' }}" />
                    <col width="{{ width: 'calc(100% / 14)' }}" />
                    <col width="{{ width: 'calc(100% / 14)' }}" />
                    <col width="{{ width: 'calc(100% / 14)' }}" />
                    <col width="{{ width: 'calc(100% / 14)' }}" />
                    <col width="{{ width: 'calc(100% / 14)' }}" />
                    <col width="{{ width: 'calc(100% / 14)' }}" />
                  </colgroup>
                  <thead>
                    <tr>
                      <th>
                        No
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        홍보 교사명
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        1월
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        2월
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        3월
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        4월
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        5월
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        6월
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        7월
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        8월
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        9월
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        10월
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        11월
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        12월
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>7</td>
                      <td>김홍보305</td>
                      <td className="td_point td_left">
                        64567
                        <br /> 324
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>1</td>
                      <td>김홍보305</td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>8</td>
                      <td>김홍보305</td>
                      <td></td>
                      <td className="td_point td_left">
                        64567
                        <br /> 324
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>4</td>
                      <td>김홍보305</td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>10</td>
                      <td>김홍보305</td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>

                    <tr className="summarized_rows">
                      <td className="td_point">2023</td>
                      <td className="td_point td_left">
                        시범강의 요청수
                        <br />
                        시범강의 성공 수
                        <br />
                        등록 수업 수
                        <br />
                        등록 학생 수
                      </td>
                      <td className="td_point td_left">
                        64567
                        <br />
                        324
                        <br />
                        64567
                        <br />
                        324
                      </td>
                      <td className="td_point td_left">
                        64567
                        <br />
                        324
                        <br />
                        64567
                        <br />
                        324
                      </td>
                      <td className="td_point td_left">
                        64567
                        <br />
                        324
                        <br />
                        64567
                        <br />
                        324
                      </td>
                      <td className="td_point td_left">
                        64567
                        <br />
                        324
                        <br />
                        64567
                        <br />
                        324
                      </td>
                      <td className="td_point td_left">
                        64567
                        <br />
                        324
                        <br />
                        64567
                        <br />
                        324
                      </td>
                      <td className="td_point td_left">
                        64567
                        <br />
                        324
                        <br />
                        64567
                        <br />
                        324
                      </td>
                      <td className="td_point td_left">
                        64567
                        <br />
                        324
                        <br />
                        64567
                        <br />
                        324
                      </td>
                      <td className="td_point td_left">
                        64567
                        <br />
                        324
                        <br />
                        64567
                        <br />
                        324
                      </td>
                      <td className="td_point td_left">
                        64567
                        <br />
                        324
                        <br />
                        64567
                        <br />
                        324
                      </td>
                      <td className="td_point td_left">
                        64567
                        <br />
                        324
                        <br />
                        64567
                        <br />
                        324
                      </td>
                      <td className="td_point td_left">
                        64567
                        <br />
                        324
                        <br />
                        64567
                        <br />
                        324
                      </td>
                      <td className="td_point td_left">
                        64567
                        <br />
                        324
                        <br />
                        64567
                        <br />
                        324
                      </td>
                    </tr>
                    <tr className="summarized_rows">
                      <td className="td_point">2022</td>
                      <td className="td_point td_left">
                        시범강의 요청수
                        <br />
                        시범강의 성공 수
                        <br />
                        등록 수업 수
                        <br />
                        등록 학생 수
                      </td>
                      <td className="td_point td_left">
                        64567
                        <br />
                        324
                        <br />
                        64567
                        <br />
                        324
                      </td>
                      <td className="td_point td_left">
                        64567
                        <br />
                        324
                        <br />
                        64567
                        <br />
                        324
                      </td>
                      <td className="td_point td_left">
                        64567
                        <br />
                        324
                        <br />
                        64567
                        <br />
                        324
                      </td>
                      <td className="td_point td_left">
                        64567
                        <br />
                        324
                        <br />
                        64567
                        <br />
                        324
                      </td>
                      <td className="td_point td_left">
                        64567
                        <br />
                        324
                        <br />
                        64567
                        <br />
                        324
                      </td>
                      <td className="td_point td_left">
                        64567
                        <br />
                        324
                        <br />
                        64567
                        <br />
                        324
                      </td>
                      <td className="td_point td_left">
                        64567
                        <br />
                        324
                        <br />
                        64567
                        <br />
                        324
                      </td>
                      <td className="td_point td_left">
                        64567
                        <br />
                        324
                        <br />
                        64567
                        <br />
                        324
                      </td>
                      <td className="td_point td_left">
                        64567
                        <br />
                        324
                        <br />
                        64567
                        <br />
                        324
                      </td>
                      <td className="td_point td_left">
                        64567
                        <br />
                        324
                        <br />
                        64567
                        <br />
                        324
                      </td>
                      <td className="td_point td_left">
                        64567
                        <br />
                        324
                        <br />
                        64567
                        <br />
                        324
                      </td>
                      <td className="td_point td_left">
                        64567
                        <br />
                        324
                        <br />
                        64567
                        <br />
                        324
                      </td>
                    </tr>
                    <tr className="summarized_rows">
                      <td className="td_point">증감율</td>
                      <td></td>
                      <td className="td_red td_left">
                        <span className="arrow_blue">213</span>
                        <br />
                        <span className="arrow_blue">456</span>
                        <br />
                        <span className="arrow_blue">978</span>
                        <br />
                        <span className="arrow_blue">321</span>
                      </td>
                      <td className="td_point td_left">
                        <span className="arrow_blue down">213</span>
                        <br />
                        <span className="arrow_blue down">456</span>
                        <br />
                        <span className="arrow_blue down">978</span>
                        <br />
                        <span className="arrow_blue down">321</span>
                      </td>
                      <td className="td_point td_left">
                        <span className="arrow_blue down">213</span>
                        <br />
                        <span className="arrow_blue down">456</span>
                        <br />
                        <span className="arrow_blue down">978</span>
                        <br />
                        <span className="arrow_blue down">321</span>
                      </td>
                      <td className="td_point td_left">
                        <span className="arrow_blue down">213</span>
                        <br />
                        <span className="arrow_blue down">456</span>
                        <br />
                        <span className="arrow_blue down">978</span>
                        <br />
                        <span className="arrow_blue down">321</span>
                      </td>
                      <td className="td_point td_left">
                        <span className="arrow_blue down">213</span>
                        <br />
                        <span className="arrow_blue down">456</span>
                        <br />
                        <span className="arrow_blue down">978</span>
                        <br />
                        <span className="arrow_blue down">321</span>
                      </td>
                      <td className="td_point td_left">
                        <span className="arrow_blue down">213</span>
                        <br />
                        <span className="arrow_blue down">456</span>
                        <br />
                        <span className="arrow_blue down">978</span>
                        <br />
                        <span className="arrow_blue down">321</span>
                      </td>
                      <td className="td_point td_left">
                        <span className="arrow_blue down">213</span>
                        <br />
                        <span className="arrow_blue down">456</span>
                        <br />
                        <span className="arrow_blue down">978</span>
                        <br />
                        <span className="arrow_blue down">321</span>
                      </td>
                      <td className="td_point td_left">
                        <span className="arrow_blue down">213</span>
                        <br />
                        <span className="arrow_blue down">456</span>
                        <br />
                        <span className="arrow_blue down">978</span>
                        <br />
                        <span className="arrow_blue down">321</span>
                      </td>
                      <td className="td_point td_left">
                        <span className="arrow_blue down">213</span>
                        <br />
                        <span className="arrow_blue down">456</span>
                        <br />
                        <span className="arrow_blue down">978</span>
                        <br />
                        <span className="arrow_blue down">321</span>
                      </td>
                      <td className="td_point td_left">
                        <span className="arrow_blue down">213</span>
                        <br />
                        <span className="arrow_blue down">456</span>
                        <br />
                        <span className="arrow_blue down">978</span>
                        <br />
                        <span className="arrow_blue down">321</span>
                      </td>
                      <td className="td_point td_left">
                        <span className="arrow_blue down">213</span>
                        <br />
                        <span className="arrow_blue down">456</span>
                        <br />
                        <span className="arrow_blue down">978</span>
                        <br />
                        <span className="arrow_blue down">321</span>
                      </td>
                      <td className="td_point td_left">
                        <span className="arrow_blue down">213</span>
                        <br />
                        <span className="arrow_blue down">456</span>
                        <br />
                        <span className="arrow_blue down">978</span>
                        <br />
                        <span className="arrow_blue down">321</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <Paging />
              </div>
            )}
            {/* promotion call by subject */}
            {tabIdx === 2 && (
              <div className="subject_wrapper">
                <div className="com_chart_wrap">
                  <div className="chart_body">
                    <div className="chart_name">
                      <div className="chart_item">
                        <span className="chart_name_label">시범강의 요청 수</span>
                        <div className="chart_slider chart_orange"></div>
                      </div>
                      <div className="chart_item">
                        <span className="chart_name_label">시범강의 성공 수</span>
                        <div className="chart_slider chart_blue"></div>
                      </div>
                      <div className="chart_item">
                        <span className="chart_name_label">등록 수업 수</span>
                        <div className="chart_slider chart_gray"></div>
                      </div>
                      <div className="chart_item">
                        <span className="chart_name_label">등록 학생 수</span>
                        <div className="chart_slider chart_indigo"></div>
                      </div>
                    </div>
                    <div className="chart_content">
                      <LineChart data={lineChartDataSubject} width={lineChartWidth} height={lineChartHeight} />
                    </div>
                  </div>
                </div>
                <table className="com_board_list">
                  <colgroup>
                    <col width="calc(100% / 18)" span="18" />
                  </colgroup>
                  <thead>
                    <tr>
                      <th>
                        순위
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        홍보자
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>등록 학생수</th>
                      <th>국어</th>
                      <th>영어</th>
                      <th>수학</th>
                      <th>과탐</th>
                      <th>사탐</th>
                      <th>논술</th>
                      <th>수시</th>
                      <th>
                        첫 수업
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        첫 달 과목추가
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        취소
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        중단
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        인계
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        종료
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        총 입금액
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                      <th>
                        총 인정 금액
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>1</td>
                      <td>김홍보103</td>
                      <td>12</td>
                      <td>2</td>
                      <td>2</td>
                      <td>2</td>
                      <td>2</td>
                      <td>2</td>
                      <td>2</td>
                      <td>2</td>
                      <td>45</td>
                      <td>2</td>
                      <td>4</td>
                      <td>2</td>
                      <td>3</td>
                      <td>7</td>
                      <td className="td_point">6547,000</td>
                      <td className="td_point">6547,000</td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td>김홍보103</td>
                      <td>12</td>
                      <td>2</td>
                      <td>2</td>
                      <td>2</td>
                      <td>2</td>
                      <td>2</td>
                      <td>2</td>
                      <td>2</td>
                      <td>45</td>
                      <td>2</td>
                      <td>4</td>
                      <td>2</td>
                      <td>3</td>
                      <td>7</td>
                      <td className="td_point">6547,000</td>
                      <td className="td_point">6547,000</td>
                    </tr>
                    <tr>
                      <td>3</td>
                      <td>김홍보103</td>
                      <td>12</td>
                      <td>2</td>
                      <td>2</td>
                      <td>2</td>
                      <td>2</td>
                      <td>2</td>
                      <td>2</td>
                      <td>2</td>
                      <td>45</td>
                      <td>2</td>
                      <td>4</td>
                      <td>2</td>
                      <td>3</td>
                      <td>7</td>
                      <td className="td_point">6547,000</td>
                      <td className="td_point">6547,000</td>
                    </tr>
                    <tr>
                      <td>4</td>
                      <td>김홍보103</td>
                      <td>12</td>
                      <td>2</td>
                      <td>2</td>
                      <td>2</td>
                      <td>2</td>
                      <td>2</td>
                      <td>2</td>
                      <td>2</td>
                      <td>45</td>
                      <td>2</td>
                      <td>4</td>
                      <td>2</td>
                      <td>3</td>
                      <td>7</td>
                      <td className="td_point">6547,000</td>
                      <td className="td_point">6547,000</td>
                    </tr>
                    <tr>
                      <td>5</td>
                      <td>김홍보103</td>
                      <td>12</td>
                      <td>2</td>
                      <td>2</td>
                      <td>2</td>
                      <td>2</td>
                      <td>2</td>
                      <td>2</td>
                      <td>2</td>
                      <td>45</td>
                      <td>2</td>
                      <td>4</td>
                      <td>2</td>
                      <td>3</td>
                      <td>7</td>
                      <td className="td_point">6547,000</td>
                      <td className="td_point">6547,000</td>
                    </tr>
                    <tr>
                      <td>7</td>
                      <td>김홍보103</td>
                      <td>12</td>
                      <td>2</td>
                      <td>2</td>
                      <td>2</td>
                      <td>2</td>
                      <td>2</td>
                      <td>2</td>
                      <td>2</td>
                      <td>45</td>
                      <td>2</td>
                      <td>4</td>
                      <td>2</td>
                      <td>3</td>
                      <td>7</td>
                      <td className="td_point">6547,000</td>
                      <td className="td_point">6547,000</td>
                    </tr>
                  </tbody>
                </table>
                <Paging />
              </div>
            )}
          </div>
        </section>
      </div>
    </main>
  );
};

export default PromotionCall;
